import { useActionData, useLoaderData } from '@remix-run/react'

export const useLoaderActionData = <
  ActionData extends { status?: boolean; formError?: string; error?: string },
>() => {
  const loaderData = useLoaderData<ActionData>()
  const actionData = useActionData<ActionData>()

  return { ...loaderData, ...actionData }
}
